import { render } from "./BoardPackets.vue?vue&type=template&id=57f541f9"
import script from "./BoardPackets.vue?vue&type=script&lang=js"
export * from "./BoardPackets.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__